<template>
    <ListeCompteEntreprise/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeCompteEntreprise from "@/components/GesCom/CompteEntreprise/ListeCompteEntreprise.vue";

    export default defineComponent({
      name: "ListeCompteEntreprisePage",
      components: {
        
        ListeCompteEntreprise,
      },
    });
  </script>